// VistaProductos.jsx
import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Categories from "../components/Categories";
import ProductCard from "../components/ProductCard";
import { productos } from "../data/productos";

const ProductsView = ({ categoria }) => {
  const [query, setQuery] = useState("");

  // Filtrar por búsqueda y por categoría (si existe)
  const filteredProducts = productos.filter((producto) => {
    const matchNombre = producto.nombre.toLowerCase().includes(query.toLowerCase());
    const matchCategoria = categoria ? producto.categoria === categoria : true;
    return matchNombre && matchCategoria;
  });

  return (
    <div
      className="relative flex min-h-screen flex-col bg-white overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="px-10 flex flex-1 flex-col items-center py-5">
        <div className="flex flex-col w-full max-w-[960px]">
          <SearchBar onSearch={setQuery} />
          <Categories />
          <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-5 p-4">
            {filteredProducts.map((producto, index) => (
              <ProductCard key={index} {...producto} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsView;
